import { gql } from '@apollo/client'

export default gql`
  fragment MoneyPreview on Money {
    value
    currencyCode
  }
`
